import '@/assets/css/control-messages.css'
import '@/assets/css/control-panels.css'
import '@/assets/css/control-modern.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { applyBrandTheme } from './config/brand'

applyBrandTheme()

//代号20221222-1
import { request, requestSceneRule, lightRequest, otherRequest, extranet_ip_request, asyncMessageKeyRequest } from './network/request' ///导入网络请求模块
Vue.prototype.$request = request ///将网络请求模块挂到VUE的原型链上
Vue.prototype.$requestSceneRule = requestSceneRule ///将网络请求模块挂到VUE的原型链上
Vue.prototype.$lightRequest = lightRequest ///将网络请求模块挂到VUE的原型链上
Vue.prototype.$otherRequest = otherRequest ///将网络请求模块挂到VUE的原型链上
Vue.prototype.$extranet_ip_request = extranet_ip_request ///将网络请求模块挂到VUE的原型链上
Vue.prototype.$asyncMessageKeyRequest = asyncMessageKeyRequest ///


import toastRegistry from './components/common/toast/index' ////toast弹窗组件
Vue.use(toastRegistry) ////挂到原型链上

import {
  showControlToast,
  closeControlToast
} from './components/content/control-toast/index'
Vue.use(showControlToast) ////挂到原型链上  各个设备的二级控制页面的弹窗组件
Vue.use(closeControlToast)

// import {
//   showConfigToast,
//   closeConfigToast
// } from './components/content/config-toast/index'
// Vue.use(showConfigToast) ////挂到原型链上 场景配置页面各个设备的弹窗组件
// Vue.use(closeConfigToast)

import {
  UseShowLoading,
  UseCloseLoading
} from './components/common/loading/index'
Vue.use(UseShowLoading) ////挂到原型链上  加载中等待的组件
Vue.use(UseCloseLoading)

import {
  UseShowTipsToast,
  UseCloseTipsToast
} from './components/common/tips-toast/index'
Vue.use(UseShowTipsToast) ////挂到原型链上  提示信息弹窗及二级控制的组件
Vue.use(UseCloseTipsToast)

import {
  UseShowTips1Toast,
  UseCloseTips1Toast
} from './components/common/tips1-toast/index'
Vue.use(UseShowTips1Toast) ////挂到原型链上  提示信息弹窗  主要用在二级控制的组件之前的信息提示，避免同一个组件一起显示，关闭出问题
Vue.use(UseCloseTips1Toast)

///全局引入第三方图表插件方法1
// import echarts from 'echarts' //  version: 4.6.0  第三方图表插件
// Vue.prototype.$echarts = echarts

///按需引入第三方图表插件方法2
// 引入基本模板
let echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/bar')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
// require('echarts/lib/component/title')
Vue.prototype.$echarts = echarts

/////复制到粘贴板的插件
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
///传递全局消息
// Vue.prototype.bus = new Vue() // <- 指向这个实例
//构建信息的提示
Vue.config.productionTip = false

const vm = new Vue({
  router,
  store,
  render: h => h(App) ///这里的意思是 相当于挂载 template 模板  即组件 App.VUE的模板
}).$mount('#app') ///这里的意思  相当于挂载el：“#app”

export default vm

// node版本 v12.13.0
// npm  6.12.0(跟随 node 版本来的,下载对应node版本 即可,无需管理)
// 具体多品牌运行和打包命令见 README.md
